/**
 * Helper functions for shopping list filtering and utilities
 */

/**
 * Filters shopping items to only show active/incomplete items
 * @param {Array} items - Array of shopping items
 * @returns {Array} - Filtered array of active items
 */
export const getActiveShoppingItems = (items) => {
  if (!Array.isArray(items)) return [];
  
  return items.filter(item => 
    item.status !== 'purchased' && 
    item.status !== 'completed' && 
    item.status !== 'deleted' &&
    item.status !== 'archived' &&
    item.status !== 'cancelled'
  );
};

/**
 * Filters shopping items to only show completed/purchased items
 * @param {Array} items - Array of shopping items
 * @returns {Array} - Filtered array of completed items
 */
export const getCompletedShoppingItems = (items) => {
  if (!Array.isArray(items)) return [];
  
  return items.filter(item => 
    item.status === 'purchased' || 
    item.status === 'completed'
  );
};

/**
 * Gets recent active shopping items, sorted by creation date
 * @param {Array} items - Array of shopping items
 * @param {number} limit - Number of items to return (default: 3)
 * @returns {Array} - Recent active items
 */
export const getRecentActiveShoppingItems = (items, limit = 3) => {
  const activeItems = getActiveShoppingItems(items);
  
  return activeItems
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .slice(0, limit);
};

/**
 * Checks if a shopping item is active/incomplete
 * @param {Object} item - Shopping item object
 * @returns {boolean} - True if item is active
 */
export const isActiveShoppingItem = (item) => {
  if (!item || !item.status) return true; // Default to active if no status
  
  const inactiveStatuses = ['purchased', 'completed', 'deleted', 'archived', 'cancelled'];
  return !inactiveStatuses.includes(item.status);
};